/* eslint-disable no-prototype-builtins */
/* eslint-disable react-hooks/rules-of-hooks */
import { Instance, types } from "mobx-state-tree";
import { withSetPropAction } from "./helpers/withSetPropAction";

const CacheBuyTogetherOpts = types.model("CacheBuyTogetherOpts", {
  selectedSkuIds: types.array(types.string),
  totalPrice: types.string,
})

export const DpStoreModel = types
  .model("DpStore")
  .props({
    buyTogetherState: types.map(CacheBuyTogetherOpts),
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    changeBuyTogetherState(unitOptId: string, selectedSkuIds: string[], totalPrice: string) {
      self.buyTogetherState.set(unitOptId, {
        selectedSkuIds: selectedSkuIds,
        totalPrice: totalPrice,
      })
    },
    getBuyTogetherState(unitOptId: string) {
      if (self.buyTogetherState.has(unitOptId)) {
        return self.buyTogetherState.get(unitOptId)
      } else {
        return {
          selectedSkuIds: [],
          totalPrice: '0',
        }
      }
    },
  }));

export interface DpStoreModel extends Instance<typeof DpStoreModel> {}
